import request from "../utils/request";

export const list = (data) => request.get("/api/logs", data);
export const history = (data) => request.get("/api/logs", data);
export const historyTemplate = (data) => request.get("/api/logs/history/template", data);
